import React, { useState, useCallback, useEffect } from 'react';
import CarnetCommande from './CarnetCommande';
import BonsLivraison from './BonsLivraison';
import BackOrders from './BackOrders';
import carnetCommandeApi from '../services/carnet-commande';
import './SuiviPiecesAtelier.css';

export default function SuiviPiecesAtelier({ user, setHeaderAction }) {
  const [activeTab, setActiveTab] = useState('carnet');
  const [carnetData, setCarnetData] = useState([]);
  const [carnetLoading, setCarnetLoading] = useState(true);

  const loadCarnet = useCallback(async () => {
    setCarnetLoading(true);
    try {
      const res = await carnetCommandeApi.getAll();
      setCarnetData(res.data);
    } catch {
      // silencieux
    } finally {
      setCarnetLoading(false);
    }
  }, []);

  useEffect(() => { loadCarnet(); }, [loadCarnet]);

  return (
    <div className="page-container">
      {/* Onglets */}
      <div className="page-tabs">
        <button className={activeTab === 'carnet' ? 'active' : ''} onClick={() => setActiveTab('carnet')}>
          📋 Carnet de Commande
        </button>
        <button className={activeTab === 'bons-livraison' ? 'active' : ''} onClick={() => setActiveTab('bons-livraison')}>
          📦 Bons de Livraison
        </button>
        <button className={activeTab === 'back-orders' ? 'active' : ''} onClick={() => setActiveTab('back-orders')}>
          <span className="bo-icon">BO</span> Back Orders
        </button>
      </div>

      {activeTab === 'carnet' && <CarnetCommande user={user} rows={carnetData} loading={carnetLoading} reload={loadCarnet} setHeaderAction={setHeaderAction} />}
      {activeTab === 'bons-livraison' && <BonsLivraison user={user} setHeaderAction={setHeaderAction} />}
      {activeTab === 'back-orders' && <BackOrders user={user} rows={carnetData} loading={carnetLoading} reload={loadCarnet} setHeaderAction={setHeaderAction} />}
    </div>
  );
}
